
import { defineComponent } from 'vue'

interface ZSelectT extends Vue {
  selected: string | number
  onChange: (val: string | number) => void
  open: boolean
}

export default defineComponent({
  name: 'ZOption',
  props: {
    label: {
      type: String
    },
    value: {
      type: [String, Number]
    },
    textSize: {
      type: String,
      default: 'text-xs'
    }
  },

  computed: {
    selected(): boolean {
      const $parent = this.$parent as ZSelectT
      return this.value === $parent.selected
    },
    textSizeClass(): string {
      const validTextSizes = ['text-xs', 'text-sm', 'text-base', 'text-lg', 'text-xl']
      return validTextSizes.includes(this.textSize) ? this.textSize : 'text-xs'
    }
  },

  methods: {
    selectOption(): void {
      if (this.value) {
        const $parent = this.$parent as ZSelectT
        $parent.onChange(this.value)
        $parent.open = false
      }
    }
  }
})
